import {FC, PropsWithChildren} from "react";
import {Button, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

interface Props extends PropsWithChildren{
    onLeft: VoidFunction;
    onRight: VoidFunction;
}

const LeftRightSelector: FC<Props> = (props) => {
    return (
        <Row className={"border w-160px"}>
            <Button className={"w-30px"} onClick={() => props.onLeft()} variant={"outline-primary"}>
                <FontAwesomeIcon icon={faArrowLeft}/>
            </Button>
            <span className={"lh-2em w-75px text-center bg-primary-light"}>
                { props.children }
            </span>
            <Button className={"w-30px"} onClick={() => props.onRight()} variant={"outline-primary"}>
                <FontAwesomeIcon icon={faArrowRight}/>
            </Button>
        </Row>
    );
}

export default LeftRightSelector;
